import {ValueObject} from '@s-ui/domain'

export default class ReportAdsRequestValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} params
   * @param {Number} params.adId
   * @param {Number} params.queryTypeId
   * @param {String} params.description
   * @param {String} params.captchaToken
   */
  constructor({adId, queryTypeId, description, captchaToken}) {
    super({adId, queryTypeId, description, captchaToken})
    this._adId = adId
    this._queryTypeId = queryTypeId
    this._description = description
    this._captchaToken = captchaToken
  }

  /**
   * Validate ReportAdsRequestValueObject parameteres
   * @static
   */
  static validate({adId, queryTypeId, invalidError} = {}) {
    if (!adId || !queryTypeId) {
      throw invalidError(`[ReportAdsRequestValueObject] Bad request parameters`)
    }
  }
}
